import React from 'react';
import './OrDivider.css';

const OrDivider: React.FC = () => (
    <div className="divider"><span>or</span></div>
)
export default OrDivider;